export const HOME = '/'
export const YEARBOOK = '/yearbook'